import { AlertCircle } from 'lucide-react'

export const BackendError = ({ backendConfigError }: { backendConfigError: string }) => {
  return (
    <div className="space-y-8 p-4 md:p-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">
          Calendar Connections
        </h1>
        <p className="text-gray-600 mt-1">
          Connect a calendar to allow the AI Employee to manage your
          appointments. Only one calendar can be active at a time.
        </p>
      </div>
      <div className="p-6 bg-red-50 border border-red-200 rounded-lg">
        <div className="flex items-center">
          <AlertCircle className="h-5 w-5 text-red-500 mr-2" />
          <span className="text-lg font-semibold text-red-700">
            Critical Backend Misconfiguration
          </span>
        </div>
        <p className="mt-2 text-red-600">{backendConfigError}</p>
        <p className="mt-1 text-sm text-red-500">
          Please contact support or check server logs. Calendar integrations
          are currently unavailable.
        </p>
      </div>
    </div>
  )
}